<template>
    <div class="inner-wrapper">
   <div class="page-title">
      <h1 class="float-left">My Profile</h1>
   </div>
   <ValidationObserver v-slot="{ handleSubmit }">
   <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq">
        <div class="mb-3 row">
                <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong class="success_msg">{{errorMessage}}</strong>
                </div>
                <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box shadow-sm mb-3">

                    <div class="card-body">

                        <div class="d-flex">
                            <div class="form-group flex-fill">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <label>Name</label>
                                <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.name">
                                <span class="error-message">{{ errors[0] }}</span>
                            </validation-provider>
                            </div>
                            <div class="form-group flex-fill">
                                <label>Contact Number</label>
                                <input type="text" class="form-control" name="address" placeholder="" v-model="form.contact_no">
                            </div>

                            <div class="form-group flex-fill">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <label>Ext</label>
                                <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.ext" />
                                <span class="error-message">{{ errors[0] }}</span>
                            </validation-provider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box shadow-sm mb-3">

                    <div class="card-body">

                        <div class="d-flex">

                            <div class="form-group flex-fill">
                                <label>Address</label>
                                <input type="text" class="form-control" placeholder="" name="fax" id="address" v-model="form.address" />
                            </div>
                            <div class="form-group flex-fill">
                                <label>Fax</label>
                                <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
                            </div>
                            <div class="form-group flex-fill">
                                <label>Title</label>
                                <input type="text" class="form-control" placeholder="" name="fax" id="title_sign" v-model="form.title_sign" />
                            </div>
                            <div class="form-group flex-fill">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <label>Quote Assigned Letter</label>
                                <input type="text" class="form-control" placeholder="" name="fax" id="quote_assigned_letter" v-model="form.quote_assigned_letter" />
                                <span class="error-message">{{ errors[0] }}</span>
                            </validation-provider>
                            </div>

                        </div>
                    </div>
                </div>




            </div>
        </div>
            <div class="btnrow text-right">
                <router-link :to="{name: 'viewCustomers'}" class="btn skip-btn">Discard</router-link>
                <button type="submit" class="btn custom-btn ml-3" id="save_customer_btn">Save</button>
                <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
            </div>
      </div>
   </form>
   </ValidationObserver>
   <div class="copyright">
      <p>© Copyright 2021. All right reserved. Superb Packaging Inc.</p>
   </div>
</div>
</template>
<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('positive', value => {

  if (value >= 0) {
    return true;
  }
  return 'Please enter only number';
});
export default {
    name: "Profile",
    components: {
        ValidationProvider,ValidationObserver
    },
    created() {
        if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        //console.log('getAuthUser',this.getAuthUser.id);
        this.getCustomer();
        this.setSuccessMessage(null);
    },
    data(){
        return {
            salesRep: {
                data:[]
            },
            customerData: {
                customer: null,
                contacts: [],
                country_data: null,
                customer_contact: null,
                countries: [],
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            },
            form: {
                name: null,
                email: null,
                quote_assigned_letter: null,
                ext: null,
                contact_no: null,
                fax: null,
                address: null,
                title_sign: null,

            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('profile.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.form = data.data;
                        console.log("profile data ",data.data)
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.put(window.route('profile.update', {id: this.getAuthUser.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.message);
                       // self.getCustomer();
                        setTimeout(() => {
                           self.setSuccessMessage(null);
                        }, 3500);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
